var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAnxietyWorry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.055 20.8376C12.2431 20.3242 12.8108 20.0595 13.3251 20.2454L13.8464 20.4339C14.3637 20.6209 14.6304 21.1928 14.4411 21.7094L12.6897 26.4897C12.5016 27.0031 11.9338 27.2678 11.4196 27.0819L10.8983 26.8934C10.381 26.7064 10.1143 26.1344 10.3035 25.6179L12.055 20.8376Z",
    fill: "#5AA0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7019 23.2239C17.89 22.7105 18.4578 22.4457 18.972 22.6316L19.4933 22.8201C20.0106 23.0072 20.2773 23.5791 20.0881 24.0956L16.2497 34.5718C16.0616 35.0852 15.4938 35.3499 14.9796 35.164L14.4583 34.9755C13.941 34.7885 13.6743 34.2165 13.8636 33.7L17.7019 23.2239Z",
    fill: "#5AA0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1284 20.485C25.3165 19.9716 25.8843 19.7068 26.3985 19.8927L26.9198 20.0812C27.4371 20.2683 27.7038 20.8402 27.5145 21.3567L24.8936 28.5103C24.7054 29.0237 24.1377 29.2884 23.6235 29.1025L23.1022 28.914C22.5849 28.727 22.3182 28.155 22.5074 27.6385L25.1284 20.485Z",
    fill: "#5AA0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5621 17.5821C21.0818 17.5821 20.7093 17.1179 20.7691 16.5936C21.2111 12.7043 24.2267 9.69482 27.8814 9.69482C31.5361 9.69482 34.5517 12.7043 34.9937 16.5936C35.0532 17.1179 34.6807 17.5821 34.2007 17.5821L21.5621 17.5821Z",
    fill: "#AAAAAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6241 17.6023C10.009 17.6023 9.53193 17.0078 9.60844 16.3361C10.1746 11.3546 14.0372 7.5 18.7182 7.5C23.3992 7.5 27.2618 11.3546 27.8279 16.3361C27.9041 17.0078 27.427 17.6023 26.8122 17.6023L10.6241 17.6023Z",
    fill: "#D0D0D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60198 17.5739C5.24013 17.5739 4.9595 17.2242 5.0045 16.8291C5.33754 13.8988 7.60963 11.6313 10.3632 11.6313C13.1167 11.6313 15.3888 13.8988 15.7219 16.8291C15.7667 17.2242 15.486 17.5739 15.1244 17.5739H5.60198Z",
    fill: "#AAAAAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnxietyWorry);
export default __webpack_public_path__ + "static/media/ic_anxiety_worry.eeb45c84723d071a86a4cc4335ffd8b4.svg";
export { ForwardRef as ReactComponent };